<template>
  <div>
    <div class="d-flex justify-end align-center mb-2">
      <template v-if="selectedKeys.length">
        <span class="text--secondary mr-2">
          Фильтр проводок по статьям: {{ selectedKeys.length }}
        </span>
        <a class="mr-3" @click="selectedKeys = []">Сбросить</a>
      </template>
      <span class="text--secondary mr-3" v-if="ratesEmpty">Ставки на {{ year }} год не заданы</span>
      <a v-if="isAdmin" @click="ratesDialog = true">Изменить ставки</a>
    </div>

    <div v-for="p in passports" :key="p.key" class="mb-8">
      <h3 class="mb-2">{{ p.title }}</h3>
      <div v-if="!p.data.streams.length" class="text--secondary">Нет проводок.</div>
      <div v-else class="passport-scroll">
        <table class="passport">
          <thead>
            <tr>
              <th class="metric-col">Статья</th>
              <th v-for="s in p.data.streams" :key="s.orgKey" class="num">
                {{ s.orgName }}<span class="cnt"> ({{ s.count }})</span>
              </th>
              <th class="num total">Итого</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in rows" :key="row.key" :class="{ heading: row.heading, indent: row.indent }">
              <td class="metric-col">
                <label v-if="isFilterable(row.key)" class="row-filter">
                  <input type="checkbox" :value="row.key" v-model="selectedKeys" />
                  <span>{{ row.label }}</span>
                </label>
                <span v-else>{{ row.label }}</span>
              </td>
              <td v-for="s in p.data.streams" :key="s.orgKey" class="num">{{ money(s[row.key]) }}</td>
              <td class="num total">{{ money(p.data.total[row.key]) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <RateConfigDialog
      v-if="isAdmin"
      v-model="ratesDialog"
      :default-year="year"
      @saved="onRatesSaved"
    />
  </div>
</template>

<script>
import { computePassport, PASSPORT_ROWS, FILTERABLE_ROW_KEYS } from './passportStreams';
import { getRateConfig } from '@/modules/RateConfig';
import RateConfigDialog from '@/components/rates/RateConfigDialog.vue';

export default {
  name: 'PassportStreams',
  components: { RateConfigDialog },
  props: {
    inputWirings: { type: Array, default: () => [] },
    year: { type: [Number, String], default: () => new Date().getFullYear() },
  },
  data() {
    return {
      rows: PASSPORT_ROWS,
      filterableKeys: FILTERABLE_ROW_KEYS,
      selectedKeys: [],
      ratesDialog: false,
      rateConfig: {},
    };
  },
  computed: {
    isAdmin() {
      return !!(this.$user && this.$user.roles && this.$user.roles.includes('ROLE_ADMIN'));
    },
    ratesEmpty() {
      return !this.rateConfig || Object.keys(this.rateConfig).length === 0;
    },
    calc() {
      return computePassport(this.inputWirings, this.rateConfig);
    },
    passports() {
      return [
        { key: 'plan', title: 'ПЛАН', data: this.calc.plan },
        { key: 'fact', title: 'ФАКТ', data: this.calc.fact },
      ];
    },
  },
  watch: {
    year: 'loadRates',
    selectedKeys(keys) {
      this.$emit('filter-wirings', keys.slice());
    },
  },
  methods: {
    isFilterable(key) {
      return this.filterableKeys.includes(key);
    },
    async loadRates() {
      if (this.year == null) return;
      try {
        this.rateConfig = (await getRateConfig(this.year)) || {};
      } catch (e) {
        this.rateConfig = {};
      }
    },
    onRatesSaved({ config }) {
      this.rateConfig = config || {};
      this.ratesDialog = false;
    },
    money(v) {
      return new Intl.NumberFormat('ru', {
        style: 'currency',
        currency: 'RUB',
        maximumFractionDigits: 0,
      }).format(Math.round(Number(v) || 0));
    },
  },
  async created() {
    await this.loadRates();
  },
};
</script>

<style scoped>
.passport-scroll {
  overflow-x: auto;
}
table.passport {
  border-collapse: collapse;
  font-size: 13px;
  min-width: 100%;
}
table.passport th,
table.passport td {
  border: 1px solid #e0e0e0;
  padding: 6px 10px;
}
table.passport th {
  background: #f5f7fb;
  font-weight: 500;
  text-align: right;
  white-space: nowrap;
}
table.passport th.metric-col,
table.passport td.metric-col {
  text-align: left;
  min-width: 340px;
  white-space: normal;
}
table.passport td.num,
table.passport th.num {
  text-align: right;
  white-space: nowrap;
}
table.passport .total {
  background: #f5f7fb;
  font-weight: 600;
}
table.passport tr.heading td {
  font-weight: 700;
  background: #eef1f7;
}
table.passport tr.indent td.metric-col {
  padding-left: 24px;
  color: #5b6b8c;
}
.cnt {
  color: #90a0bd;
  font-weight: 400;
}
.row-filter {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  cursor: pointer;
  margin: 0;
}
.row-filter input {
  margin-top: 2px;
  flex: 0 0 auto;
}
</style>
